/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MediaVersionFromJSON, MediaVersionToJSON, } from './MediaVersion';
/**
 * Check if a given object implements the MediaDownloadRequest interface.
 */
export function instanceOfMediaDownloadRequest(value) {
    let isInstance = true;
    return isInstance;
}
export function MediaDownloadRequestFromJSON(json) {
    return MediaDownloadRequestFromJSONTyped(json, false);
}
export function MediaDownloadRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'version': !exists(json, 'version') ? undefined : MediaVersionFromJSON(json['version']),
        'acknowledgeRisk': !exists(json, 'acknowledgeRisk') ? undefined : json['acknowledgeRisk'],
    };
}
export function MediaDownloadRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': MediaVersionToJSON(value.version),
        'acknowledgeRisk': value.acknowledgeRisk,
    };
}
